import React, { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { useMediaQuery } from '@mui/material';
import { getMerchandiseByFamily, getFamilies, deleteMerchandise } from '../../../services/api';
import { Button } from 'primereact/button';
import DetalhesModal from '../../modals/detalhesmerchandise'; // Modal de detalhes
import ConfirmModal from '../../modals/confirmx'; // Modal de confirmação

const VerArtigosPorFamilia = () => {
    const [articles, setArticles] = useState([]);
    const [families, setFamilies] = useState([]);
    const [selectedFamily, setSelectedFamily] = useState(null);
    const [loading, setLoading] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showDetalhesModal, setShowDetalhesModal] = useState(false);
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [productToDelete, setProductToDelete] = useState(null);
    const isMobile = useMediaQuery('(max-width:800px)');

    // Busca os artigos sem filtro no backend (para filtragem no cliente)
    const fetchArticles = async () => {
        setLoading(true);
        try {
            const response = await getMerchandiseByFamily();
            setArticles(response.data);
        } catch (error) {
            console.error("Erro ao buscar artigos por família", error);
        }
        setLoading(false);
    };

    // Busca as famílias disponíveis
    const fetchFamilies = async () => {
        try {
            const response = await getFamilies();
            setFamilies(response.data);
        } catch (error) {
            console.error("Erro ao buscar famílias", error);
        }
    };

    useEffect(() => {
        fetchArticles();
        fetchFamilies();
    }, []);

    // Atualiza o filtro ao selecionar uma família
    const onFamilyChange = (e) => {
        const family = e.value;
        setSelectedFamily(family);
    };

    // Filtra os artigos com base na família selecionada
    const filteredArticles = selectedFamily
        ? articles.filter(article => article.family === selectedFamily.name)
        : articles;

    // Template para exibir o estoque
    const stockBodyTemplate = (rowData) => rowData.current_quantity || 0;

    // Template para exibir a família
    const familyBodyTemplate = (rowData) => rowData.family ? rowData.family : "Sem família";

    // Ações: visualizar detalhes e excluir
    const actionBodyTemplate = (rowData) => {
        return (
            <div>
                <Button 
                    icon="pi pi-info-circle" 
                    className="p-button-rounded p-button-text" 
                    onClick={() => handleViewDetails(rowData)}
                />
                <Button 
                    icon="pi pi-trash" 
                    className="p-button-rounded p-button-text p-button-danger" 
                    onClick={() => handleDeleteClick(rowData)}
                />
            </div>
        );
    };

    // Abre a modal de detalhes
    const handleViewDetails = (rowData) => {
        setSelectedProduct(rowData);
        setShowDetalhesModal(true);
    };

    // Ao clicar no botão de excluir, abre a modal de confirmação
    const handleDeleteClick = (rowData) => {
        setProductToDelete(rowData);
        setShowConfirmDelete(true);
    };

    // Confirma a exclusão chamando a API
    const confirmDelete = async () => {
        try {
            await deleteMerchandise(productToDelete.id);
            setArticles(prev => prev.filter(product => product.id !== productToDelete.id));
        } catch (error) {
            console.error("Erro ao eliminar produto", error);
        } finally {
            setShowConfirmDelete(false);
            setProductToDelete(null);
        }
    };

    // Header combinando InputText e Dropdown
    const header = (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem' }}>
            <span className="p-input-icon-right" style={{ flex: 1 }}>
                <InputText 
                    type="search" 
                    onInput={(e) => setGlobalFilter(e.target.value)} 
                    placeholder="Pesquisar por nome, referência, etc." 
                    size="50" 
                />
                <i className="pi pi-search" style={{ right: '10px' }} />
            </span>
            <Dropdown 
                value={selectedFamily} 
                options={families} 
                onChange={onFamilyChange} 
                placeholder="Selecione uma família" 
                optionLabel="name"
                style={{ minWidth: '200px' }}
            />
        </div>
    );

    return (
        <Card title="Artigos por Família">
            <DataTable 
                value={filteredArticles} 
                paginator 
                rows={isMobile ? 5 : 10} 
                header={header} 
                globalFilter={globalFilter} 
                loading={loading}
                responsiveLayout="scroll"
                emptyMessage="Nenhum artigo encontrado."
            >
                <Column field="name" header="Nome" sortable />
                <Column field="reference" header="Referência" sortable />
                <Column body={stockBodyTemplate} header="Stock" sortable />
                <Column body={familyBodyTemplate} header="Família" sortable />
                <Column body={actionBodyTemplate} header="Ações" exportable={false} style={{ minWidth: '8rem' }} />
            </DataTable>

            {/* Modal de detalhes */}
            <DetalhesModal 
                visible={showDetalhesModal} 
                onHide={() => setShowDetalhesModal(false)} 
                merchandise={selectedProduct}
            />

            {/* Modal de confirmação para exclusão */}
            <ConfirmModal 
                visible={showConfirmDelete}
                message={`Tem certeza que deseja eliminar o produto ${productToDelete ? productToDelete.name : ''}?`}
                onConfirm={confirmDelete}
                onCancel={() => {
                    setShowConfirmDelete(false);
                    setProductToDelete(null);
                }}
            />
        </Card>
    );
};

export default VerArtigosPorFamilia;
